/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useUnidadeMedidaV2 = ({ unidadesIds }) => {
  const [unidadesMedida, setUnidadesMedida] = useState([]);

  useEffect(() => {
    const fetchUnidadesMedida = async () => {
      let query = db.unidadeMedidas;
      const unidades = [];

      if (unidadesIds?.length > 0) {
        query = query.where("id").anyOf(unidadesIds);
      }

      await query
        .filter((unidade) => unidade.ativo)
        .each((unidade) => {
          unidades.push(unidade);
        });
      setUnidadesMedida(unidades);
    };

    fetchUnidadesMedida();
  }, [unidadesIds]);

  const optionUnidadesMedida = useMemo(
    () => prepareForOptions(unidadesMedida, ["codigo", "nome"], "id"),
    [unidadesMedida, unidadesIds]
  );

  return {
    optionUnidadesMedida,
  };
};

export default useUnidadeMedidaV2;
